import React from 'react'

const SalesReportFooter = () => {
  return (
    <div className='sales-report-footer'>SalesReportFooter</div>
  )
}

export default SalesReportFooter;